/**
 * Converts a URL query string into an object.
 *
 * @param {string} [search=''] - The query string of the URL.
 * @returns {Object} An object containing key-value pairs of the query parameters.
 *
 * @example
 *
 * // returns { foo: 'test', bar: 'hello' }
 * convertUrlQueryParams('?foo=test&bar=hello')
 */
export function convertUrlQueryParams(search = ``) {
  if (!search) {
    return {}
  }

  let result = {}

  try {
    result = JSON.parse(
      `{"${decodeURI(search.substring(1))
        .replace(/"/g, `\\"`)
        .replace(/&/g, `","`)
        .replace(/=/g, `":"`)}"}`,
    )
    // eslint-disable-next-line no-empty
  } catch (e) {}

  return result
}
